import { render, staticRenderFns } from "./FolderModal.vue?vue&type=template&id=35c86309&scoped=true"
import script from "./FolderModal.vue?vue&type=script&lang=js"
export * from "./FolderModal.vue?vue&type=script&lang=js"
import style0 from "./FolderModal.vue?vue&type=style&index=0&id=35c86309&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c86309",
  null
  
)

export default component.exports